import type { MantineThemeColors } from '@mantine/core';
import { palette } from './chownow-palette';

export const mantineColors: Partial<MantineThemeColors> = {
  neutral: [
    palette.neutral.x1,
    palette.neutral.x1,
    palette.neutral.x2,
    palette.neutral.x3,
    palette.neutral.x4,
    palette.neutral.x5,
    palette.neutral.x6,
    palette.neutral.x7,
    palette.neutral.x8,
    palette.neutral.x9,
  ],
  blue: [
    palette.blue.x1,
    palette.blue.x1,
    palette.blue.x2,
    palette.blue.x3,
    palette.blue.x3,
    palette.blue.x3,
    palette.blue.x3,
    palette.blue.x3,
    palette.blue.x3,
    palette.blue.x3,
  ],
  green: [
    palette.green.x1,
    palette.green.x1,
    palette.green.x2,
    palette.green.x3,
    palette.green.x3,
    palette.green.x3,
    palette.green.x3,
    palette.green.x3,
    palette.green.x3,
    palette.green.x3,
  ],
  pink: [
    palette.pink.x1,
    palette.pink.x1,
    palette.pink.x2,
    palette.pink.x3,
    palette.pink.x3,
    palette.pink.x3,
    palette.pink.x3,
    palette.pink.x3,
    palette.pink.x3,
    palette.pink.x3,
  ],
  yellow: [
    palette.yellow.x1,
    palette.yellow.x1,
    palette.yellow.x2,
    palette.yellow.x3,
    palette.yellow.x3,
    palette.yellow.x3,
    palette.yellow.x3,
    palette.yellow.x3,
    palette.yellow.x3,
    palette.yellow.x3,
  ],
};
